import React from 'react';
import PropTypes from 'prop-types';

export default function PasswordRequestForm({
  onChange, onSubmit, message, value,
}) {
  return (
    <div>
      <h2 className="media__heading heading heading--3">Reset password</h2>
      <p>Please enter your email address to reset your password</p>
      <form style={{ padding: '24px 0' }} onSubmit={onSubmit}>
        <label htmlFor="emaillAddress">Email address: </label>
        <input
          className="form__control"
          type="email"
          name="emailAddress"
          id="emailAddress"
          value={value}
          onChange={onChange}
        />
        {message ? <p dangerouslySetInnerHTML={{ __html: message }} /> : null}
        <div style={{ textAlign: 'right', paddingTop: 24 }}>
          <button
            className="button button--primary"
            disabled={!value}
            type="subnmit"
          >
            Reset password
          </button>
        </div>
      </form>
    </div>
  );
}
PasswordRequestForm.propTypes = {
  message: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

PasswordRequestForm.defaultProps = {
  message: undefined,
};